import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { Role } from '@fametrue/shared';
import { useAuth } from '../auth/AuthProvider';
import { Loader } from './Loader';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Se indicati, solo questi ruoli possono vedere la rotta. */
  allow?: Role[];
}

/**
 * Barriera lato interfaccia. Non è un controllo di sicurezza: l'autorizzazione
 * vera sta nell'API e nelle policy RLS. Serve a non mostrare rotte che
 * risponderebbero comunque 401 o 403.
 */
export function ProtectedRoute({ children, allow }: ProtectedRouteProps): ReactNode {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Stesso fondo navy della login, così l'attesa di /auth/me non produce un
  // lampo di bianco prima di sapere se l'utente è autenticato.
  if (isLoading) return <Loader fullscreen />;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allow && !allow.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
